(function() {
  'use strict';

  angular.module('mgpCorregedoriaApp.info').factory('InfoService', InfoService);

  function InfoService($http, ngsalConfig) {

    var service = {
      getInfo: getInfo
    };

    return service;

    function getInfo() {

      let promise = $http.get(`/mgp-corregedoria/api/${ngsalConfig.apiVersion}/info`).then(response => response.data);

      return promise;
    }
  }
})();